import React, { useState } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import CustomButton from "../../Components/common/Button";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import DateRangePicker from "../../Components/DeliveryNote/DateRangePicker";
import { Clear } from "@mui/icons-material";
import TextField from "../../Components/common/TextField";
import { checkPrivileges } from "../../Helpers";

const MainProcessInvoices = ({ translate, handleHeaderSearch }) => {
  const [searchValues, setSearchValues] = useState({
    poNumber: "",
    poRefNumber: ""
  })
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { key: "", label: "saleOrder" },
    { key: "individual", label: "individualDn" },
  ];
  const handleSearchValues = (name, e) => {
    setSearchValues((prevState) => ({
      ...prevState,
      [name]: e.target.value
    }))
  }

  const submitSearch = () => {
    handleHeaderSearch({
      poNumber: searchValues.poNumber,
      poRefNumber: searchValues.poRefNumber
    })
  }
  let currentPath = location.pathname.replace("/process-invoices", "");
  if (currentPath.startsWith("/")) currentPath = currentPath.slice(1);
  if (currentPath === "" || currentPath === "/") currentPath = "";

  const hideParent = currentPath === "view";
  const isIndividual = currentPath === "individual"

  return (
    <>
      {!hideParent && (
        <Grid
          container
          spacing={2}
          mt={0.3}
          key={currentPath}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} sm={6}>
            <Grid container spacing={1}>
              {tabs.map((tab) => (
                <Grid item xs={6} sm={4} key={tab.key}>
                  <CustomButton
                    variant="contained"
                    onClick={() => {
                      navigate(tab.key)
                    }}
                    style={{
                      width: "100%",
                      borderTopRightRadius: "15px",
                      borderTopLeftRadius: "15px",
                      backgroundColor:
                        currentPath === tab.key ? "#00C179" : "#fff",
                      color: currentPath === tab.key ? "#fff" : "#00C179",
                    }}
                  >
                    {translate(tab.label)}
                  </CustomButton>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
              <Grid item>
                <TextField
                  label={translate('searchSoNumber')}
                  value={searchValues.poNumber}
                  onChange={(e) => handleSearchValues("poNumber", e)}
                  sx={{ minWidth: 200 }}
                />
              </Grid>
              <Grid item>
                <TextField
                  label={translate('searchSoRefNumber')}
                  value={searchValues.poRefNumber}
                  onChange={(e) => handleSearchValues("poRefNumber", e)}
                  sx={{ minWidth: 200 }}
                />
              </Grid>
              <Grid item>
                <CustomButton
                  style={{ minWidth: "80px" }}
                  onClick={submitSearch}

                >
                  {translate("search")}
                </CustomButton>
              </Grid>
              {isIndividual&&checkPrivileges("deliverynote")&&checkPrivileges("porequestCreate")&&checkPrivileges("porequestPoInvoiceGenerate") &&
                <Grid item>
                  <CustomButton
                    style={{ minWidth: "80px" }}
                    onClick={() => navigate("view")}
                  >
                    {translate("gen.Invoice")}
                  </CustomButton>
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>
      )}
      <Outlet />
    </>
  );
};

export default MainProcessInvoices;
